/**
 * stateMachineTheme — one palette for the State Machine editor (ENG-1061).
 *
 * NVIDIA Omniverse OmniGraph look (Florent's reference): a NEUTRAL dark slate
 * canvas and slate node bodies, with a single controlled CYAN/TEAL accent for
 * the ACTIVE state and selection — no saturated-green flood. Wires sit back in
 * muted steel; only the active / selected / hovered edge steps forward in cyan.
 *
 * These are FUNCTIONAL colors (graph node/edge/canvas category coding) and live
 * under components/nodes/ so the palette lock treats them as unlimited. This is
 * the ONE source of truth for the SM view's colors — a palette change is a
 * one-file edit here. Consumed by StateNode, EntryNode, TransitionEdge and
 * StateMachineEditor's SM-view chrome.
 */
export const SM_THEME = {
  // Canvas — neutral dark slate, faint grid
  canvasBg: '#202327',
  dots:     '#2c3037',

  // State node surfaces — slate bodies, cyan for meaning
  nodeBg:             '#2a2f35',
  nodeBgSelected:     '#313a44',
  nodeBgActive:       '#243740',
  nodeBorder:         '#3b434d',
  nodeBorderSelected: '#4aa8d8',   // Omniverse selection blue
  nodeBorderActive:   '#33c0c0',   // teal/cyan accent
  nodeGlowActive:     '0 0 12px rgba(60,190,205,0.35)',
  handle:             '#4aa8d8',
  progressTrack:      '#1a1d21',
  progressFill:       '#33c0c0',

  // Text
  labelState:  '#7a838d',   // "STATE"
  labelActive: '#5fd6d6',   // "▶ ACTIVE"
  title:       '#e2e8ee',   // state name
  hint:        '#5a636d',   // "double-click to edit"
  breadcrumbFaint: '#6a737d',
  breadcrumbName:  '#a9d8e8',

  // Entry pill
  entryBg:     '#233038',
  entryBorder: '#3a8fb0',
  entryText:   '#6fd0e0',

  // Transition edges
  edgeIdle:   '#4a5a66',
  edgeActive: '#33c0c0',
  edgeSelected: '#4aa8d8',
  edgeHover:  '#6fe6e6',
  edgeDimmed: '#39434d',
  marker:     '#4a6472',
  edgeGlowHover:  'drop-shadow(0 0 3px rgba(110,225,225,0.55))',
  edgeGlowActive: 'drop-shadow(0 0 3px rgba(60,190,205,0.35))',

  // Toolbar / buttons
  btnBg:      '#2a333b',
  btnBorder:  '#3a8fb0',
  btnText:    '#8fd6e6',
  backBg:     '#24282d',
  backBorder: '#3b434d',
  backText:   '#a9b6c0',
}
